import { createEnumeratorAttrMap, IEnumeratorModel } from "./IEnumeratorModel";

export type IHlavniPredmetCinnostiModel = IEnumeratorModel;
export const HlavniPredmetCinnostiAttrMap = createEnumeratorAttrMap('Hlavni_predmet_cin');
